import { j } from "./jsx-runtime-3tyXYecC.mjs";
import { T as B } from "./text-field-ZOMRKQAY.mjs";
import { g as D } from "./get-aria-describedby-G1wcWKF2.mjs";
import { u as E } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as V } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { a as A } from "./add-rhf-default-error-messages-DzyaQrlA.mjs";
import { c as M } from "./combine-function-calls-C5qD-ZYI.mjs";
import { e as S } from "./extract-rhf-validation-rule-value-DyB3XAHu.mjs";
function O({
  ariaDescribedby: l,
  control: f,
  defaultValue: u = "",
  disabled: e,
  errorMessageId: t,
  inputProps: W,
  onBlur: m,
  onChange: a,
  maxLength: p,
  minLength: c,
  name: s,
  pattern: g,
  required: r = !1,
  shouldUnregister: F,
  status: R,
  validate: d,
  ...x
}) {
  var i;
  const { field: v, fieldState: o } = E({
    control: f,
    defaultValue: u,
    name: s,
    // This is a workaround for `disabled` because it is not available in `useController` yet (not available until v7.48.0).
    rules: V(
      {
        /* eslint-disable sort-keys */
        ...A({
          required: r,
          maxLength: p,
          minLength: c,
          pattern: g
        }),
        /* eslint-enable sort-keys */
        validate: d
      },
      e
    ),
    shouldUnregister: F
  }), { onBlur: C, onChange: H, ref: b, value: h = "" } = v;
  function y(T) {
    const { value: n = "" } = T.target;
    H(n), typeof a == "function" && a(n);
  }
  return /* @__PURE__ */ j.jsx(
    B,
    {
      ...x,
      ariaDescribedby: D(o.error ? t : void 0, l),
      disabled: e,
      errorMessage: t || (i = o.error) == null ? void 0 : i.message,
      name: s,
      onBlur: M(C, m),
      onChange: y,
      ref: b,
      required: typeof r == "string" ? !!r : S(r),
      status: o.error ? "error" : R,
      value: h
    }
  );
}
export {
  O as T
};
//# sourceMappingURL=text-field-rhf-BcIvHLbk.mjs.map
